import { z } from 'zod';

export const PlatformsQuerySchema = z.object({
  excludeDeleted: z.boolean().optional(),
  excludeNotIntegrated: z.boolean().optional(),
});

export const IntegrationType = z.enum([
  'two_way',
  'one_way',
  'virtual',
] as const);

export const IntegrationCategory = z.enum([
  'integrated',
  'publisher',
  'dsp',
  'ad_network',
  'ad_server',
  'dmp',
  'brand_safety',
  'web_analytics',
] as const);

export const PlatformsResponseSchema = z.array(
  z.object({
    id: z.number(),
    platform: z.string(),
    label: z.string(),
    channels: z.array(z.string()),
    description: z.string(),
    category: IntegrationCategory,
    logo: z.string().or(z.null()),
    type: IntegrationType,
    isDeleted: z.boolean(),
    isIntegrated: z.boolean().or(z.null()),
    integrationsCount: z.number().or(z.null()),
    isOmni: z.boolean().optional(),
  }),
);

export type PlatformsResponse = z.infer<typeof PlatformsResponseSchema>;
export type Platform = PlatformsResponse[number];
